import React from "react";
import resim1 from "../headerimg/buse1.png";
import { FaLinkedinIn, FaGithub, FaMoon } from "react-icons/fa";

const Header = (props) => {
  return (
    <div
      id={props.isNightMode ? "dark" : "light"}
      className="general-container-header">
      <div className="explanation-container-header">
        <span id={props.isNightMode ? "dark" : "light"} className="hi">
          Hi! 👋{" "}
        </span>

        <h3 id={props.isNightMode ? "dark" : "light"} className="introduction">
          I’m Buse Mutluoglu. I’m a full-stack developer. I can craft solid and
          scalable frontend products. Let’s meet!
        </h3>
        <p className="links">
          <a href="https://www.linkedin.com/in/buse-mutluoglu-18a8a8a0/">
            {" "}
            <FaLinkedinIn
              style={{ color: "black" }}
              className="linkedin"
            />{" "}
          </a>
          <a href="https://github.com/BuseMutluoglu">
            {" "}
            <FaGithub style={{ color: "black" }} className="github" />
          </a>
          <a>
            <FaMoon
              className="moon"
              id={props.isNightMode ? "dark" : "light"}
              onClick={props.toggleTheme}
            />
          </a>
        </p>
        <p id={props.isNightMode ? "dark" : "light"} className="notes">
          Currently <span>Freelancing</span> for
          <span> UX, UI, & Web Design</span> Project. Invite me to join your
          team→{" "}
          <a className="mail" href="mailto:busemutluoglu@gmail.com">
            busemutluoglu@gmail.com
          </a>
        </p>
      </div>

      <img className="header-photo" src={resim1} alt="ProfilePhoto" />
    </div>
  );
};

export default Header;
